import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import IconsContext from '../../Context/IconsContext';
import ModalLayout from '../ModalLayout';

export default function DeleteCustomerOTAModalDisplay(props) {
  const {
    isOpen,
    toggleModal,
    handleCustomerOTADelete,
    error,
    deleteRequestPending,
    customerOTAselected,
  } = props;
  const { commandControlIcon } = useContext(IconsContext);
  return (
    <ModalLayout
      centered
      isOpen={isOpen}
      scrollable
      size="lg"
      toggle={toggleModal}
    >
      <ModalHeader className="pb-0 border-bottom-0" toggle={props.toggleModal}>
        <img
          src={commandControlIcon}
          alt="command icon"
          className="img-fluid mx-auto"
          style={{ height: '4rem' }}
        />
        <p className="mb-0 modal-title-text text-center">
          Delete Customer OTA file?
        </p>
      </ModalHeader>
      <ModalBody className="p-3 px-md-4 container-fluid d-flex flex-column">
        <div className="row justify-content-center mt-3">
          <p className="col-12 col-md-10 text-left text-muted">
            This will delete this OTA file from platform storage
          </p>
        </div>
        <div className="row justify-content-center mt-3">
          <p className="col-12 col-md-10 text-left text-muted">
            selected: {customerOTAselected.typeName}{' '}
            {customerOTAselected.filename},{' '}
            {customerOTAselected.properties.contentLength} bytes, created{' '}
            {customerOTAselected.createdOn} ago
          </p>
        </div>
        <div className="flex-fill row justify-content-center">
          <p className="col-12 col-md-10 text-danger text-right">{error}</p>
        </div>
      </ModalBody>
      <ModalFooter className="justify-content-between border-0 px-md-4">
        <button
          className="btn btn-outline-secondary px-4 py-0 nine-tenth-text"
          onClick={toggleModal}
        >
          Cancel
        </button>
        <button
          className="btn btn-danger px-4 py-0 nine-tenth-text"
          onClick={handleCustomerOTADelete}
        >
          {deleteRequestPending ? (
            <FontAwesomeIcon icon={faCircleNotch} spin size="lg" />
          ) : (
            'Yes, Delete'
          )}
        </button>
      </ModalFooter>
      <style jsx global>{`
        .modal-title {
          display: flex;
          flex-direction: column;
          flex-grow: 1;
          justify-content: center;
          margin-right: -1.5rem;
        }
      `}</style>
    </ModalLayout>
  );
}

DeleteCustomerOTAModalDisplay.propTypes = {
  isOpen: PropTypes.bool,
  toggleModal: PropTypes.func,
  handleCustomerOTADelete: PropTypes.func,
  error: PropTypes.string,
  deleteRequestPending: PropTypes.bool,
  customerOTAselected: PropTypes.shape({
    filename: PropTypes.string, // just the filename
    displayName: PropTypes.string, // the filename but maybe truncated for display
    name: PropTypes.string, // blob storage name
    type: PropTypes.string, // just the prefix like "hfx_flash"
    typeName: PropTypes.string, // name found from looking up in our types table
    properties: PropTypes.object, // from blob storage
    createdOn: PropTypes.string, // "x ago" string from properties.createdOn time
  }),
};
